import Estado from "../../assets/LogoGovernoBranco.svg";
import Esat from "../../assets/esat.svg";
import Sefaz from "../../assets/LogoSefaz.png";

export const Header = () => {
  return (
    <>
      <div id="main" className="flex justify-between">
        <a href="https://paraiba.pb.gov.br/" target="_blank">
          <img src={Estado} alt="Estado" width={135} />
        </a>
        <a href="https://sesat1.sefaz.pb.gov.br/esat/" target="_blank">
          <img src={Esat} alt="Esat" width={80} className="mt-[1px]" />
        </a>
        <a href="https://www.sefaz.pb.gov.br/" target="_blank">
          <img src={Sefaz} alt="Sefaz" width={105} className="mt-1" />
        </a>
      </div>
    </>
  );
};

export default Header;